import { useMutation } from '@tanstack/react-query';
import { verifyEmail } from 'shared/services/backend-api';

export const useVerifyEmailMutation = () =>
  useMutation({
    mutationFn: async (code?: string) => {
      await verifyEmail(code ?? '');
    },
  });
